import { ContentBrick } from '../../../app-kit/components/ContentBrick/ContentBrick';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import type { FunctionComponent } from 'react';
import { PropertyMapBrick } from './PropertyMapBrick';

export const PropertyMapBrickWithData: FunctionComponent = () => {
  const queryResult = usePropertyPageQuery();
  if (!queryResult) return null;
  const { fetching, data } = queryResult;
  if (!data || fetching) return null;

  const propertyMap = data?.propertyPageBySlugV3?.propertyMap;
  if (!propertyMap) return null;

  const {
    pins,
    title,
    subtitle,
    tracking,
    propertyBoundary,
    buildingBoundaries,
    propertyBoundaryMeasurements,
    propertyBoundaryLandAreas,
    propertyBoundaryVertices,
  } = propertyMap;

  const flattenedPins = pins?.flatMap(({ coordinates }) => coordinates);

  return (
    <ContentBrick title={title} subtitle={subtitle} subtitleAs="p">
      <PropertyMapBrick
        pins={flattenedPins}
        title={title}
        subtitle={subtitle}
        tracking={tracking}
        propertyBoundary={propertyBoundary}
        buildingBoundaries={buildingBoundaries}
        propertyBoundaryMeasurements={propertyBoundaryMeasurements}
        propertyBoundaryLandAreas={propertyBoundaryLandAreas}
        propertyBoundaryVertices={propertyBoundaryVertices}
      />
    </ContentBrick>
  );
};
